<div class="notification-menu" (click)="$event.stopPropagation()">
  <div class="np-header">
    <span class="np-title">{{ 'notifications' | translate }}</span>

    @if (selectedTab && selectedTab.value === NotificationTab.INBOX && notificationService.unreadNotificationList && notificationService.unreadNotificationList.length) {
      <button
        type="button"
        mat-stroked-button
        class="np-mark-all np--black"
        (click)="onMarkAllRead($event)">
        {{ 'mark_all_as_read' | translate }}
      </button>
    }
  </div>

  @if (tabsAlive) {
    <app-tabs-v2
      [tabList]="tabs"
      (onSelectTab)="onChangeTab($event)" />
  }

  @if (selectedTab) {
    @switch (selectedTab.value) {
      @case (NotificationTab.INBOX) {
        <div class="np-list">
          @if (!(notificationService.unreadNotificationList && notificationService.unreadNotificationList.length)) {
            <div class="np-empty">Немає нових сповіщень</div>
          } @else {
            @for (notification of notificationService.unreadNotificationList; track $index) {
              <ng-container *ngTemplateOutlet="notificationItem; context: { notification }" />
            }
          }
        </div>
      }
      @case (NotificationTab.ARCHIVED) {
        <div class="np-list">
          @for (notification of notificationService.readNotificationList; track $index) {
            <ng-container *ngTemplateOutlet="notificationItem; context: { notification }" />
          }
        </div>
      }
    }
  }
</div>

<!-- item -->
<ng-template let-n="notification" #notificationItem>
  @if (n.x_data?.kind !== 'fiscal_operation' || n.x_data.code) {
    <div class="np-item" [class.unread]="!n.is_read">
      <div class="np-avatar">
        <img
          [src]="'https://ui-avatars.com/api/?name=JECRM&background='+primaryColor+'&color='+textColor"
          alt="">
      </div>

      <div class="np-body">
        <div class="np-name">
          {{ n.x_data?.kind === 'fiscal_operation' ? fiscalNotifications.format(n.x_data).title : n.title }}
          @if (!n.is_read) { <i class="np-dot"></i> }
        </div>

        @if (n.x_data?.kind === 'fiscal_operation') {
          <span class="np-message notification-message">{{ fiscalNotifications.format(n.x_data).message }}</span>
        } @else {
        <span
          class="np-message notification-message"
          (click)="$event.stopPropagation()"
          [innerHTML]="getNotificationMessage(n.message) | safeHtml"></span>
        }

        @if (n.planner || n.channel) {
          <div class="np-meta">
            @if (n.planner) {
              <span class="np-meta-item">Планер: {{ n.planner }}</span>
            }
            @if (n.channel) {
              <span class="np-meta-item">Канал: {{ n.channel }}</span>
            }
          </div>
        }

        <div class="np-time">{{ n.created_at | date:'dd.MM.yy, HH:mm' }}</div>
      </div>

      <!-- Оверлей: клік по ВСІЙ картці -->
      <div class="np-cover" (click)="onItemClick(n, $event)"></div>
    </div>
  }
</ng-template>
